import './token-renew-button.component.scoped.scss'

export default () => {
  return (
    <div className="token-renew-button">
      <i className="fa-solid fa-diamond-exclamation yellow" style={{ zIndex: 1 }} />
    </div>
  )
}
